import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGoogleCalendarRegularIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "m22.316 9.684-5.684-.631-6.948.631L9.053 16l.631 6.316 6.316.79 6.316-.79.632-6.474z",
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.275 19.483q-.709-.478-.977-1.4l1.096-.452q.15.569.52.881.371.312.898.311.537 0 .923-.327.387-.328.387-.832 0-.516-.407-.843-.409-.327-1.02-.327h-.633V15.41h.568q.526 0 .886-.284t.36-.778a.86.86 0 0 0-.322-.703q-.322-.263-.817-.263-.483 0-.767.257a1.5 1.5 0 0 0-.414.633l-1.084-.451q.214-.612.794-1.079t1.48-.467q.666 0 1.198.257.53.258.832.714.3.457.3 1.025 0 .579-.28.982a1.9 1.9 0 0 1-.687.617v.065c.359.15.65.379.882.687q.343.461.344 1.105 0 .645-.327 1.15-.328.504-.902.793t-1.293.291a2.7 2.7 0 0 1-1.538-.477M19 14.045l-1.196.87-.602-.912 2.159-1.557h.827v7.343h-1.187z",
			fill: "#1a73e8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22.316 28 28 22.316l-2.842-1.263-2.842 1.263-1.263 2.842z",
			fill: "#ea4335"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.42 25.158 9.685 28h12.632v-5.684H9.684z",
			fill: "#34a853"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.895 4A1.894 1.894 0 0 0 4 5.895v16.42l2.842 1.264 2.842-1.263V9.684h12.632l1.263-2.842L22.316 4z",
			fill: "#4285f4"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4 22.316v3.79C4 27.151 4.848 28 5.895 28h3.79v-5.684z",
			fill: "#188038"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22.316 9.684v12.632h5.685V9.684l-2.843-1.263z",
			fill: "#fbbc04"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M28 9.684v-3.79A1.894 1.894 0 0 0 26.107 4h-3.79v5.684z",
			fill: "#1967d2"
		})
	]
});
export default SvgGoogleCalendarRegularIcon;
